module.exports = __webpack_public_path__ + "img/Import-and-Export.cf23effe.svg";